const apiUrl = (process.env.NODE_ENV === "development" ? "http://localhost:8101/v2/widget" : "https://api.snapguest.pro/v2/widget")

export { apiUrl }
